<template>
  <div class="layoutContainer">
    <!-- pc -->
    <div v-if="!$deviceState.isMobile">
      <el-container>
        <!-- aside -->
        <el-aside width="auto">
          <ComponentAside></ComponentAside>
        </el-aside>
        <el-container>
          <!-- header -->
          <el-header height="auto">
            <ComponentHeader></ComponentHeader>
          </el-header>
          <el-main class="set-scroll">
            <!-- Main -->
            <!-- content -->
            <!-- <router-view></router-view> -->
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
          </el-main>
        </el-container>
      </el-container>
    </div>

    <!-- mb -->
    <div v-else>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>

<script>
import ComponentAside from '@/components/aside/index.vue'
import ComponentHeader from '@/components/header/index.vue'
export default {
  name: 'LayoutIndex',
  components: { ComponentAside, ComponentHeader },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.layoutContainer {
  // background-color: rgb(@layoutColour);
  background-color: #74737622;
  width: 100%;
  // height: 100vh;
}
.content {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  box-sizing: border-box;
}
.el-header {
  padding: 0;
}
.el-aside {
  overflow: hidden;
  // background-color: red;
  // background-color: rgb(@asideClour);
}
.el-main {
  padding: 0;
}
.el-container {
  // height: calc(100vh - 28px);
  height: 100vh;
}
</style>
